if (!customElements.get("product-ladder-side")) {
  customElements.define(
    "product-ladder-side",
    class ProductLadderSide extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.error = this.querySelector("[data-ladder-side-error]");
        this.addEventListener("change", () => {
          if (this.error) this.error.hidden = true;
        });
      }

      validateSelection() {
        const selected = this.querySelector("[data-ladder-side-choice]:checked");
        if (this.error) this.error.hidden = Boolean(selected);
        if (!selected) this.querySelector("[data-ladder-side-choice]")?.focus();
        return Boolean(selected);
      }

      applySelection(form) {
        const selected = this.querySelector("[data-ladder-side-choice]:checked");
        if (!selected || !form) return;
        let input = form.querySelector('input[data-ladder-side-property]');
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "properties[Ladder side]";
          input.dataset.ladderSideProperty = "true";
          form.appendChild(input);
        }
        input.value = selected.value;
      }
    }
  );
}
